import React, { useEffect, useMemo, useState } from 'react';
import { SUPER_ADMIN_UIDS } from '../../constants/appConfig';
import Modal from '../../components/common/Modal.js';
import '../../styles/GestionDeUsuarios.css';
import { ROLE_DESCRIPTIONS } from '../../constants/permissionCatalog.js';

const ROLE_OPTIONS = [
    {
        value: 'admin',
        label: 'Administrador',
        highlights: ['Acceso total al panel', 'Puede aprobar aportes y retiros'],
    },
    {
        value: 'support',
        label: 'Soporte',
        highlights: ['Gestiona tickets de soporte', 'Consulta reportes y notificaciones'],
    },
    {
        value: 'user',
        label: 'Usuario',
        highlights: ['Sin acceso al panel admin', 'Usa solo la app de participante'],
    },
];

export const PermissionsModal = ({ user, onSave, onClose, processing }) => {
    const [selectedRole, setSelectedRole] = useState('user');

    const isSuperAdmin = useMemo(() => (user ? SUPER_ADMIN_UIDS.includes(user.id) : false), [user]);

    useEffect(() => {
        if (!user) return;
        const rawRole = (user.roleKey && user.roleKey !== 'superadmin') ? user.roleKey : (user.role || 'user');
        setSelectedRole(['admin', 'support'].includes(rawRole) ? rawRole : 'user');
    }, [user]);

    const handleSave = () => {
        if (isSuperAdmin) return;
        onSave(user.id, { role: selectedRole });
    };

    return (
        <Modal isOpen={true} onClose={onClose} title={`Asignar rol a ${user.fullName}`}>
            <div className="permissions-modal simple">
                <section className="permissions-section">
                    <h4>Selecciona un rol</h4>
                    <p className="permissions-hint">Los permisos base de cada rol se administran desde la nueva sección "Permisos" del menú.</p>
                    <div className="role-options">
                        {ROLE_OPTIONS.map((option) => {
                            const isActive = selectedRole === option.value;
                            const description = ROLE_DESCRIPTIONS[option.value]?.summary || '';
                            return (
                                <label
                                    key={option.value}
                                    className={`role-option ${isActive ? 'role-option--active' : ''}`}
                                >
                                    <input
                                        type="radio"
                                        name="role"
                                        value={option.value}
                                        checked={isActive}
                                        disabled={isSuperAdmin || processing}
                                        onChange={() => setSelectedRole(option.value)}
                                    />
                                    <div className="role-option__content">
                                        <span className="role-option__title">{option.label}</span>
                                        <span className="role-option__description">{description}</span>
                                        <ul className="role-option__highlights">
                                            {option.highlights.map(item => <li key={item}>{item}</li>)}
                                        </ul>
                                    </div>
                                </label>
                            );
                        })}
                    </div>
                    {isSuperAdmin && (
                        <p className="permissions-warning">Este usuario es Super Admin y ya posee todos los permisos. No se puede modificar.</p>) }
                </section>

                <div className="permissions-actions">
                    <button onClick={onClose} className="action-button">Cancelar</button>
                    <button
                        onClick={handleSave}
                        className="login-button"
                        disabled={processing || isSuperAdmin}
                    >
                        {processing ? 'Guardando...' : 'Guardar Cambios'}
                    </button>
                </div>
            </div>
        </Modal>
    );
};